import { render, staticRenderFns } from "./CvForm.vue?vue&type=template&id=527d354a&scoped=true&"
import script from "./CvForm.vue?vue&type=script&lang=js&"
export * from "./CvForm.vue?vue&type=script&lang=js&"
import style0 from "./CvForm.vue?vue&type=style&index=0&id=527d354a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d354a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VExpansionPanel,VExpansionPanelContent,VTab,VTabItem,VTabs,VTextarea})
